module.exports = __webpack_public_path__ + "static/img/张慧靖1.7180d0f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lbtuimaj/张慧靖1.png
// module id = f4G5
// module chunks = 1